import React, { forwardRef } from "react";

import validator from "validator";
import Input from "../../1_elements/Input";

/* Props
*  label        : string
*  inputId      : string, to identify input and link it to its label
*  placeholder  : string
*  type         : string, can be integer / string to apply validation controls
*  isReadOnly   : bool, set to true if input shouldn't be modified
*/
const InputPhone = forwardRef( function InputPhone({
    ...props
}, ref) {
    /** 
     * Control errors based on the type of input
     */
    function controlErrors(value) {
        let error = false;
        let message = "";

        if (error = props.isRequired && (!value || value?.trim().length === 0)) {
            message = "Ce champ est obligatoire";
        } else if (error = value?.trim().length > 0 && !validator.isMobilePhone(value)) {
            message = "Le format du numéro de téléphone est incorrect";            
        }

        return ({error: error, message: message});
    }

    const error = {controlErrors: controlErrors};

    return (
        <Input
            ref={ref}
            {...props}
            error={error}
            type="phone"
        />
    )
})

export default InputPhone;